<template>
  <div class="center">
    <div class="logon">
      <div>
        <div class="overlaylong-Signin">
          <div class="flex-column-align title">
            <div class="overlaylongH2">欢迎登录</div>
            <div class="line"></div>
          </div>
          
          <div class="form-container">
            <form :model="loginForm" class="flex-column-align">
              <input v-model="loginForm.studentNumber" type="text" placeholder="请输入账号" class="inputclass">
              <input v-model="loginForm.passWord" type="password" placeholder="请输入密码" class="inputclass">
            </form>
          </div>
          
          <div class="action-buttons">
            <h3 @click="reset" class="reset">重置</h3>
          </div>
          
          <button class="inupbutton" @click="handleLogin">登录</button>
          <p class="servetext">登陆即视为同意<span class="agreement">《服务协议》</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { debounce } from 'lodash';
export default {
  name: 'login',
  data() {
    return {
      loginForm: {
        studentNumber: '',
        passWord: '',
      },
    }
  },
  methods: {
      handleLogin: debounce(function() {
      this.login();
    }, 500, { leading: true, trailing: false }),
    ...mapMutations(['setUser','setToken']),
    reset() {
      this.loginForm.studentNumber = ''
      this.loginForm.passWord = ''
                this.$message({
            message: '已清空!',
            type: 'success'
          });
    },
    login() {
      this.$http.post(`${this.$config.API_BASE_URL}/hz-university-pc/user/login`, this.loginForm).then((resp) => {
        let data = resp.data;
        if(data.code == '200') {
          this.loginForm = {};
          this.$message({
            message: '恭喜你，登陆成功！',
            type: 'success'
          });
          	const token = data.data.tokenValue;
						const user = data.data.user;
            this.setToken(token);  
						this.setUser(user);
            localStorage.setItem('token', token); 
						console.log(localStorage.getItem('token'), 'tokentoken');
          	localStorage.setItem('user', JSON.stringify(user)); // 关键修改
						console.log('User:', JSON.parse(localStorage.getItem('user'))); // 读取时解析
            console.log(JSON.parse(localStorage.getItem('user')).userRole, 'userRoleuserRoleuserRoleuserRoleuserRoleuserRole');
            const Role = JSON.parse(localStorage.getItem('user')).userRole
            if(Role ==='学生'){
                  if (this.$route.path !== '/stubgc') {
                this.$router.push('/stubgc');
              }

                 }else if(Role ==='管理员'){
                       if (this.$route.path !== '/admin') {
                    this.$router.push({path:'/admin'})
                 }

                  }else if(Role ==='辅导员'){
                if (this.$route.path !== '/counsellor') {
                    this.$router.push({path:'/counsellor'})
                }
    

            }else if(Role ==='领导'){
            if (this.$route.path !== '/home') {
                   this.$router.push({path:'/home'})
                  }
            }else if(Role ==='家长'){
            if (this.$route.path !== '/parents') {
                   this.$router.push({path:'/parents'})
                  }
            }
            else if(Role ==='教师'){
            if (this.$route.path !== '/home') {
                   		this.$router.push({path:'/bgc'})
                  }
            }         
        } else {
          this.$message.error(data.msg);

        }
      });  
    },
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.line {
  width: 4.9375rem; /* 79px */
  height: 0.5rem; /* 8px */
  opacity: 1;
  background: rgba(69, 131, 250, 1);
}

.title {
  margin-top: 9.375rem; /* 150px */
}

.inputclass {
  width: 24.0625rem; /* 385px */
  height: 3.75rem; /* 60px */
  opacity: 1;
  border-radius: 2.1875rem; /* 35px */
  background: rgba(219, 237, 255, 1);
  border: none;
  padding: 0 1.25rem; /* 20px */
  margin: 0.625rem 0; /* 10px */
  font-size: 1.125rem; /* 18px */
}

.inputclass::placeholder {
  font-size: 1.125rem; /* 18px */
  font-weight: 500;
  color: rgba(196, 196, 196, 1);
}

.reset {
  font-size: 1.125rem; /* 18px */
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  cursor: pointer;
}

.servetext {
  font-size: 1.0625rem; /* 17px */
  font-weight: 500;
  color: rgba(151, 151, 151, 1);
  margin-top: 1.25rem; /* 20px */
  display: flex;
  justify-content: center;
}

.agreement {
  font-size: 1rem; /* 16px */
  font-weight: 500;
  color: rgba(57, 145, 255, 1);
}

.center {
  height: 100vh;
  width: 100vw;
  background-image: url('/src/assets/pic/bgc1x.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
 position: relative;
}

.logon {
  width: 34.375rem; /* 550px */
  height: 42.5rem; /* 680px */
  opacity: 0.8;
  border-radius: 1.875rem; /* 30px */
  background: rgba(255, 255, 255, 0.7);
  border: 0.125rem solid rgba(255, 255, 255, 1); /* 2px */
  padding: 0 3.125rem; /* 50px */
  position: absolute;
 right: 10%;
  bottom: 20%;
}

.overlaylongH2 {
  width: 7.5rem; /* 120px */
  height: 1.875rem; /* 30px */
  font-size: 1.875rem; /* 30px */
  font-weight: 700;
  margin-bottom: 0.625rem; /* 10px */
  color: rgba(0, 0, 0, 1);
}

.form-container {
  margin-top: 5rem; /* 80px */
}

.action-buttons {
  display: flex;
  justify-content: center;
  margin-top: 1.25rem; /* 20px */
text-align: center;
}

.inupbutton {
  width: 24.0625rem; /* 385px */
  height: 3.625rem; /* 58px */
  opacity: 1;
  border-radius: 1.7188rem; /* 27.5px */
  background: linear-gradient(182.83deg, rgba(75, 123, 248, 1) 0%, rgba(57, 145, 255, 1) 100%);
  border: none;
  line-height: 60px;
  margin-top: 5.5625rem; /* 89px */
  font-size: 1.625rem; /* 26px */
  font-weight: 700;
  letter-spacing: 0.3rem; /* 4.8px */
  color: rgba(255, 255, 255, 1);
  cursor: pointer;
display: flex;
justify-content: center;
text-align: center;
margin:0 auto;
margin-top: 50px;
transition: all 0.3s ease; /* 添加过渡效果 */
}
/* 鼠标悬停效果 */
.inupbutton:hover {

  border-color: #1890ff; /* 边框颜色与背景一致 */
  transform: translateY(2px); /* 轻微下移模拟按下效果 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 添加阴影增强立体感 */
}

/* 点击时的效果 */
.inupbutton:active {
  transform: translateY(4px); /* 按下时下移更多 */
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); /* 减小阴影 */
}
.flex-column-align {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>